import { render, staticRenderFns } from "./insured-vehicle-info.vue?vue&type=template&id=2b6da4f9&"
import script from "./insured-vehicle-info.vue?vue&type=script&lang=js&"
export * from "./insured-vehicle-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports